import { IconProps } from '../types';

function User(props: IconProps) {
  return (
    <svg
      {...props}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 14C12.2386 14 10 11.7614 10 9C10 6.23858 12.2386 4 15 4C17.7614 4 20 6.23858 20 9C20 11.7614 17.7614 14 15 14ZM15 12C16.6569 12 18 10.6569 18 9C18 7.34315 16.6569 6 15 6C13.3431 6 12 7.34315 12 9C12 10.6569 13.3431 12 15 12ZM6.97767 24.9998C7.52982 25.0121 7.98742 24.5745 7.99975 24.0223C8.12225 18.5373 10.3776 17 14.9999 17C19.8804 17 22.1174 18.5181 21.9954 23.9777C21.9831 24.5298 22.4207 24.9874 22.9729 24.9998C23.525 25.0121 23.9826 24.5745 23.9949 24.0223C24.141 17.4819 21.0478 15 14.9999 15C9.22368 15 6.14576 17.4627 6.00025 23.9777C5.98791 24.5298 6.42552 24.9874 6.97767 24.9998Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default User;
